<style scoped>
.invalid-length {
  color: #ff6660;
}
</style>

<template>
  <small class="form-text text-muted text-right">
    <span :class="{'invalid-length': length > maxlength}">{{ length || 0 }}</span>
    <span> / {{ maxlength }}</span>
  </small>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      required: true,
    },
  },
};
</script>
